import { FormEvent, useEffect, useMemo, useState } from "react";
import { LoadingComp } from "../../components/loading/loading.comp";
import { useRegistration } from "../../libs/registration/registration.hook";
import { RegistrationContainer } from "./styles/registration-container.style";
import { SingleInput } from "../../components/form/styles/single-input";
import { AppForm } from "../../components/form/styles/app-form";
import { StudentInfoComp } from "../../components/student-info/student-info.comp";
import { CtaButton } from "../../components/form/styles/cta-button";

export const TryoutView = () => {
  const eventId = "tryout";
  const {
    processing,
    registrationInfo,
    setRegistrationInfo,
    sendRegistration,
  } = useRegistration();
  const [submitted, setSubmitted] = useState(false);

  const isEmail =
    registrationInfo.email?.includes(".") &&
    registrationInfo.email?.includes("@");

  const canProceed = useMemo(
    () =>
      registrationInfo.students.participant?.firstName &&
      registrationInfo.students.participant?.lastName &&
      registrationInfo.firstName &&
      registrationInfo.lastName &&
      registrationInfo.phone &&
      registrationInfo.email &&
      isEmail,
    [registrationInfo]
  );

  useEffect(() => {
    setRegistrationInfo({
      event: eventId,
    });
  }, []);

  const onSubmit = async (event: FormEvent) => {
    event.preventDefault();

    if (canProceed) {
      try {
        await sendRegistration();
        setSubmitted(true);
      } catch (err) {
        alert("Registration failed. Please try again.");
      }
    }
  };

  return (
    <RegistrationContainer>
      <h1>
        Registration for <strong>Tryout Class</strong>
      </h1>

      {submitted ? (
        <h2>Thank you for registering! We will get back to you soon.</h2>
      ) : (
        <AppForm onSubmit={onSubmit}>
          <h2>Child/Participant Information</h2>
          <StudentInfoComp
            id="participant"
            showSelection={false}
            showOptional={false}
          />
          <h2>Parent / Guardian Information</h2>
          <SingleInput
            onChange={(event: any) =>
              setRegistrationInfo({ firstName: event.target.value })
            }
            value={registrationInfo.firstName}
            placeholder="First name"
          />
          <SingleInput
            onChange={(event: any) =>
              setRegistrationInfo({ lastName: event.target.value })
            }
            value={registrationInfo.lastName}
            placeholder="Last name"
          />
          <SingleInput
            onChange={(event: any) =>
              setRegistrationInfo({ email: event.target.value })
            }
            value={registrationInfo.email}
            placeholder="Email"
          />
          <SingleInput
            onChange={(event: any) =>
              setRegistrationInfo({ phone: event.target.value })
            }
            value={registrationInfo.phone}
            placeholder="Phone"
          />

          <CtaButton disabled={!canProceed}>Register</CtaButton>
          <ul className="error-summary">
            {!registrationInfo.students.participant?.firstName ? (
              <li>Participant First Name is required</li>
            ) : (
              ""
            )}
            {!registrationInfo.students.participant?.lastName ? (
              <li>Participant Last Name is required</li>
            ) : (
              ""
            )}
            {!registrationInfo.firstName ? <li>First Name is required</li> : ""}
            {!registrationInfo.lastName ? <li>Last Name is required</li> : ""}
            {!registrationInfo.phone ? <li>Phone is required</li> : ""}
            {!isEmail ? <li>Email is required</li> : ""}
          </ul>
          <br />
          <br />
        </AppForm>
      )}

      {processing && <LoadingComp />}
    </RegistrationContainer>
  );
};
